import React from 'react'
import { getValueFromResource } from '../../../common/timeLiveFunction'
import { useAppDispatch } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import ZoneFormAndMap from './ZoneFormAndMap';
import { useLocation, useParams } from 'react-router-dom';

const GeofencingZone = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const { id } = useParams();
    const zoneId = !!id;
    // const zoneId = location?.pathname?.split('/')?.[2]

    return (
        <div>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading">
                        {zoneId ? getValueFromResource('Update Zone', dispatch, t) : getValueFromResource('Add Zone', dispatch, t)}
                    </h3>
                </div>
                <div className="my-3">
                    <ZoneFormAndMap />
                </div>
            </div>
        </div>
    )
}

export default GeofencingZone